import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../common/state/hooks";
import { setAlert } from "../../alert/state/alertsSlice";
import { removeDemoBuilds } from "../../builds/state/buildsSlice";
import { getAllSessionsByProjectGroup } from "../../stats/state/statsSlice";
import { invalidateCreatorStatsCache } from "../../statsNew/state/statsNewSlice";
import { cleanupDemoData } from "../state/onboardingSlice";

type UseDemoDataCleanupOptions = {
  sessionsMode?: "summary";
  onCleaned?: () => void;
};

export const useDemoDataCleanup = ({ sessionsMode, onCleaned }: UseDemoDataCleanupOptions = {}) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const runCleanup = (): void => {
    void dispatch(cleanupDemoData()).then((action) => {
      if (cleanupDemoData.fulfilled.match(action)) {
        dispatch(removeDemoBuilds());
        dispatch(invalidateCreatorStatsCache());
        void dispatch(getAllSessionsByProjectGroup({ mode: sessionsMode, force: true }));
        onCleaned?.();
        dispatch(setAlert({ type: "success", msg: t("onboarding.demoData.deletedSuccess") }));
      } else {
        dispatch(setAlert({ type: "danger", msg: t("onboarding.demoData.deleteFail") }));
      }
    });
  };

  return { runCleanup };
};
